<template>
  <main class="content">
    <section class="main-section">
      <img
        src="/assets/hero-icons/successful-email-verification.svg"
        :alt="adminText('adminAll.successful_email_verification_8a6771', 'successful email verification')"
      >
      <div class="successful-text-container">
        <h1 class="successful-title">{{ getTitle }}</h1>
        <a v-if="!isVerified" :href="`${landingURL}`" target="_self">
          <main-button depressed :text="adminText('adminAll.nastavi_32b41d', 'nastavi')" />
        </a>
        <main-button v-else depressed :text="getButtonText" @click="handleRedirect" />
      </div>
    </section>
  </main>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
import { CONFIRM_EMAIL } from '../../graphql/user.graphql.js'
import { landingURL } from '@/utils'

const VERIFIED_MESSAGE_RESPONSE = 'User already verified'

export default {
  mixins: [AdminContext, AdminAllMessages],
  props: {
    token: {
      type: String,
    },
  },
  data() {
    return {
      landingURL,
      isVerified: false,
      isLoggedIn: false,
    }
  },
  computed: {
    getTitle() {
      return this.isVerified ? this.adminText('adminAll.vas_profil_je_vec_verificiran_58479c', 'Vaš profil je već verificiran.') : this.adminText('adminAll.uspjesna_potvrda_e_maila_12fe44', 'Uspješna potvrda e-maila')
    },
    getButtonText() {
      return this.isLoggedIn ? this.adminText('adminAll.nastavi_32b41d', 'nastavi') : this.adminText('adminAll.login_2736fa', 'login')
    },
  },
  async mounted() {
    await this.confirmEmail()
    await this.checkIfUserIsAlreadyLoggedIn()
  },
  methods: {
    async handleRedirect() {
      const path = this.isLoggedIn ? '/' : '/login'
      await this.$router.push(path)
    },
    async confirmEmail() {
      const { errors } = await this.$apollo.mutate({
        mutation: CONFIRM_EMAIL,
        variables: { token: this.token },
      })

      if (errors && errors.length > 0) {
        this.isVerified = !!errors.find(error => error.message === VERIFIED_MESSAGE_RESPONSE)
      }
    },
    async checkIfUserIsAlreadyLoggedIn() {
      await this.$store.dispatch('auth/fetchUser')
      this.isLoggedIn = !!this.$store.getters['auth/user']
    },
  },
}
</script>

<style scoped>
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}
.main-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 42rem;
  justify-self: center;
}
.successful-text-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  margin-top: 4.5rem;
}
.successful-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 800;
  font-size: 72px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.03em;
  color: #333333;
}
</style>
